import { render, staticRenderFns } from "./moneySupervision.vue?vue&type=template&id=ad4ac77a&scoped=true"
import script from "./moneySupervision.vue?vue&type=script&lang=js"
export * from "./moneySupervision.vue?vue&type=script&lang=js"
import style0 from "./moneySupervision.vue?vue&type=style&index=0&id=ad4ac77a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4ac77a",
  null
  
)

export default component.exports